import React, { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Contact = () => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            offset: 100,
            easing: 'ease-out-cubic',
        });

        // Initialize EmailJS with your public key
        emailjs.init('DwmceKM3RRTMAVd4Y');
    }, []);

    // Refs and state
    const formRef = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

    // Form submission handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus({ type: '', message: '' });

        try {
            console.log('Form data:', {
                name: formRef.current.user_name.value,
                email: formRef.current.user_email.value,
                phone: formRef.current.user_phone.value,
                service: formRef.current.service.value,
                message: formRef.current.message.value
            });

            // Send using EmailJS
            const result = await emailjs.sendForm(
                'service_czz8c8z',     // Your Zoho service ID
                'template_y4cmz9q',    // Your template ID
                formRef.current,       // Form reference
                'DwmceKM3RRTMAVd4Y'    // Your public key
            );

            console.log('EmailJS Success:', result);
            
            setSubmitStatus({
                type: 'success',
                message: '✅ Message sent successfully! We will contact you within 24 hours.'
            });
            
            // Reset form
            formRef.current.reset();
            
            // Clear success message after 8 seconds
            setTimeout(() => {
                setSubmitStatus({ type: '', message: '' });
            }, 8000);

        } catch (error) {
            console.error('EmailJS Error:', error);
            
            setSubmitStatus({
                type: 'error',
                message: error.text || '❌ Failed to send message. Please try again or email us directly at info@a2zsolutionsindia.co.in'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {/* Page Header Start */}
            <div
                className="container-fluid page-header py-5"
                style={{ marginBottom: "6rem" }}
                data-aos="fade-down"
            >
                <div className="container py-5">
                    <h1 className="display-3 text-white mb-3">Contact Us</h1>
                </div>
            </div>
            {/* Page Header End */}

            {/* Contact Information Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div
                            className="col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            <div className="bg-light p-4 rounded text-center h-100 contact-card">
                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style={{ width: "70px", height: "70px" }}>
                                    <i className="fa fa-map-marker-alt fa-2x"></i>
                                </div>
                                <h4 className="mb-3">Our Address</h4>
                                <p className="mb-0">#327, Vasantha Complex, Opposite to Raghavendra Mutt, Narayan Shastri Road, Mysore, Karnataka, India - 570004</p>
                            </div>
                        </div>

                        <div
                            className="col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <div className="bg-light p-4 rounded text-center h-100 contact-card">
                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style={{ width: "70px", height: "70px" }}>
                                    <i className="fa fa-phone-alt fa-2x"></i>
                                </div>
                                <h4 className="mb-3">Phone Numbers</h4>
                                <p className="mb-1"><strong>Support:</strong> 0821-4246005</p>
                                <p className="mb-0"><strong>Direct:</strong> +91 9886295510</p>
                            </div>
                        </div>

                        <div
                            className="col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <div className="bg-light p-4 rounded text-center h-100 contact-card">
                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style={{ width: "70px", height: "70px" }}>
                                    <i className="fa fa-envelope fa-2x"></i>
                                </div>
                                <h4 className="mb-3">Email & Business Hours</h4>
                                <p className="mb-1"><strong>Email:</strong> info@a2zsolutions.in</p>
                                <p className="mb-0"><strong>Hours:</strong> Mon-Fri: 9AM-7PM, Sat: 9AM-2PM</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Form & Map Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div
                            className="col-lg-6"
                            data-aos="fade-right"
                            data-aos-delay="100"
                        >
                            <h6 className="text-primary text-uppercase mb-2">Get In Touch</h6>
                            <h1 className="mb-4">Contact A2Z Solutions</h1>
                            <p className="mb-4">We're here to help you with your business needs. Whether you're interested in our medical billing services, data annotation, training programs, manpower solutions, or hardware equipment services, feel free to reach out to us.</p>
                            <p className="mb-4">As an ISO 9001:2015 certified company, we are committed to providing quality services and timely responses to all inquiries. Our team will get back to you within 24 hours.</p>

                            <div className="bg-light p-4 rounded form-container">
                                {/* Status Message Display */}
                                {submitStatus.message && (
                                    <div 
                                        className={`alert ${submitStatus.type === 'success' ? 'alert-success' : 'alert-danger'} 
                                            alert-dismissible fade show mb-4`} 
                                        role="alert"
                                        data-aos="fade-up"
                                    >
                                        {submitStatus.message}
                                        <button 
                                            type="button" 
                                            className="btn-close" 
                                            onClick={() => setSubmitStatus({ type: '', message: '' })}
                                        ></button>
                                    </div>
                                )}

                                {/* EmailJS Form */}
                                <form ref={formRef} onSubmit={handleSubmit}>
                                    <div className="row g-3">
                                        <div
                                            className="col-md-6"
                                            data-aos="fade-up"
                                            data-aos-delay="200"
                                        >
                                            <div className="form-floating">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    id="name" 
                                                    name="user_name" 
                                                    placeholder="Your Name" 
                                                    required 
                                                    disabled={isSubmitting}
                                                />
                                                <label htmlFor="name">Your Name *</label>
                                            </div>
                                        </div>
                                        <div
                                            className="col-md-6"
                                            data-aos="fade-up"
                                            data-aos-delay="300"
                                        >
                                            <div className="form-floating">
                                                <input 
                                                    type="email" 
                                                    className="form-control" 
                                                    id="email" 
                                                    name="user_email" 
                                                    placeholder="Your Email" 
                                                    required 
                                                    disabled={isSubmitting}
                                                />
                                                <label htmlFor="email">Your Email *</label>
                                            </div>
                                        </div>
                                        <div
                                            className="col-12"
                                            data-aos="fade-up"
                                            data-aos-delay="400"
                                        >
                                            <div className="form-floating">
                                                <input 
                                                    type="tel" 
                                                    className="form-control" 
                                                    id="phone" 
                                                    name="user_phone" 
                                                    placeholder="Phone Number" 
                                                    disabled={isSubmitting}
                                                />
                                                <label htmlFor="phone">Phone Number</label>
                                            </div>
                                        </div>
                                        <div
                                            className="col-12"
                                            data-aos="fade-up"
                                            data-aos-delay="500"
                                        >
                                            <div className="form-floating">
                                                <select 
                                                    className="form-control" 
                                                    id="service" 
                                                    name="service" 
                                                    required 
                                                    disabled={isSubmitting}
                                                >
                                                    <option value="">Select Service Interested In</option>
                                                    <option value="Academic Education">Academic Education</option>
                                                    <option value="Medical Billing Services">Medical Billing Services</option>
                                                    <option value="Annotation & Data Entry Services">Annotation & Data Entry Services</option>
                                                    <option value="Web Development">Web Development</option>
                                                    <option value="Training Services">Training Services</option>
                                                    <option value="Man Power Services">Man Power Services</option>
                                                    <option value="Computer Hardware Equipment Services">Computer Hardware Equipment Services</option>
                                                    <option value="General Inquiry">General Inquiry</option>
                                                </select>
                                                <label htmlFor="service">Service Interested In *</label>
                                            </div>
                                        </div>
                                        <div
                                            className="col-12"
                                            data-aos="fade-up"
                                            data-aos-delay="600"
                                        >
                                            <div className="form-floating">
                                                <textarea 
                                                    className="form-control" 
                                                    placeholder="Your Message" 
                                                    id="message" 
                                                    name="message" 
                                                    style={{ height: "100px" }} 
                                                    required 
                                                    disabled={isSubmitting}
                                                ></textarea>
                                                <label htmlFor="message">Your Message *</label>
                                            </div>
                                        </div>
                                        <div
                                            className="col-12"
                                            data-aos="zoom-in"
                                            data-aos-delay="700"
                                        >
                                            <button 
                                                className="btn btn-primary w-100 py-3" 
                                                type="submit"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Sending...
                                                    </>
                                                ) : 'Send Message'}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div
                            className="col-lg-6"
                            data-aos="fade-left"
                            data-aos-delay="100"
                        >
                            <div className="h-100">
                                <h6 className="text-primary text-uppercase mb-2">Our Location</h6>
                                <h1 className="mb-4">Find Us in Mysuru</h1>
                                <p className="mb-4">Visit our office in Mysuru to discuss your business requirements in person. We are conveniently located in Vasantha Complex on Narayan Shastri Road, opposite to Raghavendra Mutt.</p>

                                {/* Map Container */}
                                <div
                                    className="map-container"
                                    style={{ borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 15px rgba(0,0,0,0.1)" }}
                                    data-aos="zoom-in"
                                    data-aos-delay="200"
                                >
                                    <div style={{ width: "100%", height: "400px" }}>
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15592.67727844167!2d76.6280424!3d12.3043818!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baf700f349d86f7%3A0xf5f6df5b1ba16601!2skeonics%20NS%20Road!5e0!3m2!1sen!2sin!4v1766139824706!5m2!1sen!2sin" 
                                            width="100%"
                                            height="100%"
                                            style={{ border: "0" }}
                                            allowFullScreen={true}
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            title="A2Z Solutions Office Location">
                                        </iframe>
                                    </div>
                                </div>

                                {/* Address Card below Map */}
                                <div
                                    className="mt-4 p-3 bg-light rounded"
                                    data-aos="fade-up"
                                    data-aos-delay="300"
                                >
                                    <h6 className="mb-2"><i className="fa fa-map-marker-alt text-primary me-2"></i>Office Address</h6>
                                    <p className="mb-0">#327, Vasantha Complex, Opposite to Raghavendra Mutt, Narayan Shastri Road, Mysore, Karnataka 570004</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Custom Styles */}
            <style jsx>{`
                .page-header {
                    background: linear-gradient(rgba(6, 3, 21, 0.8), rgba(6, 3, 21, 0.8)), 
                                url('img/carousel-01.jpg') no-repeat center center;
                    background-size: cover;
                }
                
                .contact-card {
                    transition: all 0.3s ease;
                    border: 2px solid transparent;
                }
                
                .contact-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
                    border-color: #0d6efd;
                }
                
                .contact-card i {
                    transition: transform 0.3s ease;
                }
                
                .contact-card:hover i {
                    transform: scale(1.1);
                }
                
                .form-container {
                    transition: all 0.3s ease;
                }
                
                .form-container:hover {
                    box-shadow: 0 5px 20px rgba(0,0,0,0.1);
                }
                
                .form-floating input,
                .form-floating select,
                .form-floating textarea {
                    transition: all 0.3s ease;
                    border: 1px solid #dee2e6;
                }
                
                .form-floating input:focus,
                .form-floating select:focus,
                .form-floating textarea:focus {
                    border-color: #0d6efd;
                    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
                }
                
                .btn-primary {
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }
                
                .btn-primary:hover:not(:disabled) {
                    transform: translateY(-3px);
                    box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3);
                }
                
                .btn-primary:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }
                
                .map-container {
                    transition: all 0.3s ease;
                }
                
                .map-container:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
                }
                
                /* Mobile Responsiveness */
                @media (max-width: 768px) {
                    .contact-card {
                        margin-bottom: 1.5rem;
                    }
                    
                    .map-container {
                        height: 300px;
                    }
                    
                    .map-container div {
                        height: 300px;
                    }
                }
                
                @media (max-width: 576px) {
                    .page-header {
                        padding-top: 3rem;
                        padding-bottom: 3rem;
                    }
                    
                    .map-container {
                        height: 250px;
                    }
                    
                    .map-container div {
                        height: 250px;
                    }
                }
            `}</style>
        </>
    );
};

export default Contact;